export enum InputType {
  DatetimeLocal = 'datetime-local',
  Date = 'date',
}
